import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { getClassOfServiceColor, getClassOfServiceFontColor } from 'utils/classOfService';
import { StyledArrowRight } from '../../JourneyDigest.styles';
import { StyledTravelSummary } from './TravelSummary.styles';

const TravelSummary = ({ departureDate, originName, destinationName, paxDetails, classOfService }) => {
  const bgColor = getClassOfServiceColor(classOfService?.code);
  const fontColor = getClassOfServiceFontColor(classOfService?.code);

  return (
    <StyledTravelSummary bgColor={bgColor} fontColor={fontColor}>
      <p data-id="travel-date" data-testid="travel-date" className="travel-date">
        {moment(departureDate).format('dddd Do MMM YYYY')}
      </p>
      <p>
        <span data-id="origin-name" data-testid="origin-name">
          {originName}
        </span>
        <StyledArrowRight />
        <span data-id="destination-name" data-testid="destination-name">
          {destinationName} - {paxDetails && Object.keys(paxDetails).length}
        </span>{' '}
        <FormattedMessage id="journeySummary.pax" />
      </p>
    </StyledTravelSummary>
  );
};

TravelSummary.propTypes = {
  departureDate: PropTypes.string,
  originName: PropTypes.string,
  destinationName: PropTypes.string,
  classOfService: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string
  }),
  paxDetails: PropTypes.arrayOf(
    PropTypes.shape({
      disabilityType: PropTypes.string,
      id: PropTypes.string,
      isAFareAddOn: PropTypes.bool,
      name: PropTypes.string,
      passengerId: PropTypes.string,
      price: PropTypes.number,
      tariffCode: PropTypes.string,
      type: PropTypes.string
    })
  )
};

export default TravelSummary;
